/**
 * GET /api/search?q= (backend/common/search.py, implemented by the inventory slice). Groups of
 * hits keyed by kind: materials, lots, formulas, locations. Hits should carry `id`, `label`,
 * optional `detail` (CAS, code) and optional `url` (an SPA path); other field names are tolerated.
 */
import { apiGet } from "./client";

export interface SearchHit {
  id: string;
  label?: string;
  detail?: string;
  /** SPA path to open, e.g. "/lots/T030-24S". Derived from the group and id when missing. */
  url?: string;
  name?: string;
  title?: string;
  code?: string;
  cas?: string;
  [key: string]: unknown;
}

export interface SearchResponse {
  query: string;
  results: Record<string, SearchHit[]>;
}

export function searchEverything(query: string, signal?: AbortSignal): Promise<SearchResponse> {
  return apiGet<SearchResponse>("/search", { params: { q: query }, signal });
}
